import React from "react";
import {
  makeStyles,
  Theme, AppBar, Toolbar, CssBaseline, Typography,
  IconButton, Snackbar
} from "@material-ui/core";
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
})
);

interface Props {
  notification: Notification,
  handleNotificationClose: (event?: React.SyntheticEvent<Element, Event> | undefined, reason?: string | undefined) => void,
}
interface Notification {
  open: boolean,
  level: "success" | "info" | "warning" | "error" | undefined,
  message: string,
}

const LoginHeader: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { notification, handleNotificationClose } = props
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            <IconButton color="inherit">
              CIS ヘルプラインシステム
              </IconButton>
          </Typography>
        </Toolbar>
      </AppBar>
      {notification.level === 'error' ? (
        <Snackbar open={notification.open} onClose={handleNotificationClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
          <Alert onClose={handleNotificationClose} severity={notification.level} variant="filled">
            エラーが発生しました。{<br />}
            {notification.message}
          </Alert>
        </Snackbar>) : (
          <Snackbar open={notification.open} autoHideDuration={5000} onClose={handleNotificationClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
            <Alert onClose={handleNotificationClose} severity={notification.level} variant="filled">
              {notification.message}{notification.level === 'success' && 'が完了しました'}
            </Alert>
          </Snackbar>)}
    </div>
  );
};


export default LoginHeader;
